<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<ng-container *ngIf="activityData">
  <app-dynamic-grid *ngIf="gridConfig && gridClause && gridTrail && gridReport && gridSettings" [config]="gridConfig"
    [clauses]="gridClause" [trail]="gridTrail" [report]="gridReport" [settings]="gridSettings" (add)="onAddEmit()"
    (edit)="onEditEmit($event)" (reorder)="onReorderEmit($event)" (grid_settings)="onSettingsEmit()"></app-dynamic-grid>
</ng-container>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddOrEditPopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span></label>
    </div>
    <div class="frozen-popup-content">
      <div class="row">
        <div class="col-md-4">
          <div class="mb-2 d-flex">
            <div class="w-50">
              <label for="email"><b>{{qualityService.moduleName}} ID :</b></label>
            </div>
            <div class="w-50">
              <span class="tooltip-style" matTooltip="{{idMapping[qualityService.moduleName]}}">
                {{idMapping[qualityService.moduleName]}}
              </span>
            </div>
          </div>

          <div class="mb-2 d-flex">
            <div class="w-50">
              <label for="email"><b>{{qualityService.moduleName}} Status :</b></label>
            </div>
            <div class="w-50">{{qualityService.activity.status}}</div>
          </div>

          <div class="mb-2 d-flex">
            <div class="w-50">
              <label for="email">
                <b>
                  <ng-container
                    *ngIf="qualityService.moduleName == 'CR'|| qualityService.moduleName == 'CAPA' || qualityService.moduleName == 'DV'; else no">
                    Owner :
                  </ng-container>
                  <ng-template #no>
                    Evaluator :
                  </ng-template>
                </b></label>
            </div>
            <div class="w-50">
              {{qualityService.activity?.ownerUserName ?? qualityService.activity?.evaluatorUser}}
            </div>
          </div>

          <div class="mb-2 d-flex">
            <div class="w-50">
              <label for="email"><b>Expected Closure Date :</b></label>
            </div>
            <div class="w-50">
              {{qualityService.activity.expcetedClosureOn | date : (appService.getOneQmsDateFormat)}}
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="row">
            <div>
              <label for="email">
                <b>{{getDynamicDescriptionLabel()}} :</b>
              </label>
            </div>
            <div class="row d-flex align-items-center">
              <div class="hideToolbar col-sm-11">
                <ng-container *ngIf="qualityService.moduleName == 'CR'">
                  <st-editor [(ngModel)]="qualityService.activity.changeDescription" [config]="excludeButtons"
                    style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                </ng-container>
                <ng-container *ngIf="qualityService.moduleName == 'CAPA'">
                  <st-editor [(ngModel)]="qualityService.activity.capaDescription" [config]="excludeButtons"
                    style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                </ng-container>
                <ng-container *ngIf="qualityService.moduleName == 'DV'">
                  <st-editor [(ngModel)]="qualityService.activity.dvDescription" [config]="excludeButtons"
                    style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                </ng-container>
                <ng-container *ngIf="qualityService.moduleName == 'IN' || qualityService.moduleName == 'QI'">
                  <st-editor [(ngModel)]="qualityService.activity.description" [config]="excludeButtons"
                    style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                </ng-container>
                <ng-container *ngIf="qualityService.moduleName == 'CC'">
                  <st-editor [(ngModel)]="qualityService.activity.complaintDescription" [config]="excludeButtons"
                    style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                </ng-container>
              </div>
              <div class="col-sm-1 angular-editor-edit" (click)="openEditor('quality', 'eye')"
                (keydown.enter)="openEditor('quality', 'eye')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr style="color: #cfcfcf;">

    <div style="max-height: 400px; overflow-y: scroll; overflow-x: hidden; margin: 15px;" *ngIf="dynamicLabel">
      <div class="row">

        <!-- Plan Details  -->
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Plan Details</span>
          </legend>

          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-6">
              <div> <!-- Action Name -->
                <label id="action-name" for="email">
                  {{dynamicLabel['ACTION_NAME']?.fieldName}} </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['ACTION_NAME']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ACTION_NAME']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <input class="input-filed-continers" type="text" placeholder="" [(ngModel)]="action.actionName"
                [disabled]="isPlanFrozen" (ngModelChange)="onNgModelChange($event,'action-name')">
            </div>

            <div class="col-md-6" *ngIf="dynamicLabel['ACTION_DESCRIPTION']?.isRemovable != 'Y'">
              <div>
                <label for="email">
                  {{ dynamicLabel['ACTION_DESCRIPTION']?.fieldName }}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['ACTION_DESCRIPTION']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ACTION_DESCRIPTION']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>

              <div class="row d-flex align-items-center">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="action.actionDescription" [config]="excludeButtons"
                    style="min-height: 100px !important;" [spellcheck]="true" [disabled]="isPlanFrozen"
                    (paste)="onPaste($event)">
                  </st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (click)="isPlanFrozen ? openEditor('Action Description', 'eye') : openEditor('Action Description', 'edit')"
                  (keydown.enter)="isPlanFrozen ? openEditor('Action Description', 'eye') : openEditor('Action Description', 'edit')">
                  <i *ngIf="!isPlanFrozen" class="far fa-edit"></i>
                  <i *ngIf="isPlanFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['ACTION_TYPE'].isRemovable != 'Y' && qualityService.moduleName =='CAPA'">
              <div>
                <label id="action-type" for="email">
                  {{dynamicLabel['ACTION_TYPE'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['ACTION_TYPE'].fieldNotes"
                  [matTooltip]="dynamicLabel['ACTION_TYPE'].fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select matInput multiple #actionType placeholder="Select" [(ngModel)]="selectedActionType"
                (closed)="actionTypeSearchText=''" [disabled]="isPlanFrozen" (click)="focusSearch('focusSearch')"
                (keydown.enter)="focusSearch('focusSearch')">
                <input type="search" id="focusSearch" class="dropdownsearchstyle" [(ngModel)]="actionTypeSearchText"
                  matInput placeholder="search">
                <div class="select-all">
                  <mat-checkbox [(ngModel)]="isAllActionTypeSelected" (change)="toggleAllSelection('action-type')">
                    Select All
                  </mat-checkbox>
                </div>
                <mat-option *ngFor="let item1 of actionTypeDropdown | multiAssessmentSearchPipe :actionTypeSearchText"
                  [value]="item1.valueExp" (onSelectionChange)="onActionTypeSelect($event,item1)">
                  {{ item1.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3" *ngIf="visibleEditButton">
              <div>
                <label for="email">
                  {{dynamicLabel['STATUS']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['STATUS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['STATUS']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <input class="input-filed-continers" type="text" placeholder="" [(ngModel)]="action.status"
                [disabled]="true">
            </div>

            <div class="col-md-3" *ngIf="visibleEditButton">
              <label id="created-on" for="email">
                {{dynamicLabel['CREATED_ON'].fieldName}}
              </label>
              <span style="float:right" *ngIf="dynamicLabel['CREATED_ON'].fieldNotes"
                [matTooltip]="dynamicLabel['CREATED_ON'].fieldNotes">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
              </span>
              <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="$dateTimeConfig"
                [dateCustomClasses]="dateCustomClasses" [(ngModel)]="action.createdOn" [disabled]="true">
            </div>

            <div class="col-md-3">
              <div>
                <label id="target-date" for="email">
                  {{dynamicLabel['TARGET_DATE']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['TARGET_DATE']?.fieldNotes"
                  [matTooltip]="dynamicLabel['TARGET_DATE']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="$targetDateConfig"
                [dateCustomClasses]="dateCustomClasses" [(ngModel)]="action.targetDate" [disabled]="isPlanFrozen"
                (ngModelChange)="onNgModelChange($event,'target-date')">
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['ACTION_AT'].isRemovable != 'Y' && qualityService.moduleName !='CC'">
              <div>
                <label id="action-at" for="email">
                  {{dynamicLabel['ACTION_AT'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['ACTION_AT'].fieldNotes"
                  [matTooltip]="dynamicLabel['ACTION_AT'].fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="action.actionAt"
                (closed)="requestedAtSearchText=''" (click)="focusSearch('requested-at')"
                (keydown.enter)="focusSearch('requested-at')" [disabled]="isPlanFrozen"
                [ngClass]="{'odd-item-mat-select' : oddRequestedAt == action.actionAt}">
                <input type="search" id="requested-at" class="dropdownsearchstyle" [(ngModel)]="requestedAtSearchText"
                  matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onRequestedAtSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of requestedAtDropdown| assessmentSearch :requestedAtSearchText"
                  (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-6" *ngIf="action.actionAt" [matTooltip]="selectedBusinessArea">
              <div>
                <label id="business-area" for="email">
                  {{((this.businessAreaName ?? '') + ' ' + dynamicLabel['CORE_BUSINESS_AREA'].fieldName)}}</label>
                <span class="mandatory-symbol">*</span>
              </div>
              <mat-select matInput multiple #businessArea placeholder="Select" *ngIf="businessAreaDropdown.length > 0"
                [(ngModel)]="selectedBusinessArea" (closed)="businessAreaSearchText=''" [disabled]="isPlanFrozen"
                (click)="focusSearch('b-area')" (keydown.enter)="focusSearch('b-area')">
                <input type="search" id="b-area" class="dropdownsearchstyle" [(ngModel)]="businessAreaSearchText"
                  matInput placeholder="search">
                <div class="select-all">
                  <mat-checkbox [(ngModel)]="isAllBusinessAreaSelected"
                    (change)="toggleAllSelection('business-area')">Select All</mat-checkbox>
                </div>
                <mat-option
                  *ngFor="let item1 of businessAreaDropdown | multiAssessmentSearchPipe :businessAreaSearchText"
                  [value]="item1.valueExp" (onSelectionChange)="onBusinessAreaSelect($event,item1)">
                  {{ item1.displayExp }}
                </mat-option>
              </mat-select>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50" [disabled]="isPlanFrozen"
                *ngIf="businessAreaDropdown.length == 0" [(ngModel)]="selectedBusinessArea"
                (ngModelChange)="onNgModelChange($event,'business-area')"></textarea>
            </div>

            <div class="col-md-3" id="search-container">
              <div>
                <label id="assigned-to" for="email">
                  {{dynamicLabel['ASSIGNED_TO']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <label *ngIf="message.showSwitchUser" id="owner-validation" for="email"
                  (click)="searchAssignTo('switch')" (keydown.enter)="searchAssignTo('switch')">
                  <a>
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Yes" width="25"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['ASSIGNED_TO']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ASSIGNED_TO']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div style="display: flex; justify-content: center;">
                <div class="col-sm-11" style="position: relative;">
                  <input id="participantUserName" class="input-filed-continers" style="cursor: not-allowed;" type="text"
                    [(ngModel)]="action.assignedTo" [disabled]="true">
                </div>
                <div class="col-sm-1" style="padding-left: 2%; cursor: pointer;" (click)="searchAssignTo('search')"
                  *ngIf="!isPlanFrozen" (keydown.enter)="searchAssignTo('search')">
                  <i class="fa fa-search"></i>
                </div>
              </div>
            </div>

            <div class="col-md-3" *ngIf="dynamicLabel['ASSIGNED_TO_DEPARTMENT'].isRemovable != 'Y'">
              <div>
                <label for="email" id="department">
                  {{dynamicLabel['ASSIGNED_TO_DEPARTMENT'].fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['ASSIGNED_TO_DEPARTMENT'].fieldNotes"
                  [matTooltip]="dynamicLabel['ASSIGNED_TO_DEPARTMENT'].fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="action.assignedToDepartment"
                (closed)="departmentSearchText = ''" (click)="focusSearch('department-search')"
                [disabled]="isPlanFrozen"
                [ngClass]="{'odd-item-mat-select' : oddDepartment == action.assignedToDepartment}"
                (keydown.enter)="focusSearch('departmentCodeSearch')">
                <input type="search" id="department-search" class="dropdownsearchstyle"
                  [(ngModel)]="departmentSearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onDepartmentSelect($event, null)">Un-select</mat-option>
                <mat-option *ngFor="let item of departmentDropdown| assessmentSearch :departmentSearchText"
                  (onSelectionChange)="onDepartmentSelect($event, item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3" *ngIf="action.planReviewedBy">
              <div>
                <label id="plan-reviewer" for="email">
                  {{dynamicLabel['PLAN_REVIEWER']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <label for="email" *ngIf="message.showSwitchUser && !action.planReviewCompletedOn"
                  (click)="openSwitchUser('Plan Reviewer')" (keydown.enter)="openSwitchUser('Plan Reviewer')">
                  <a>
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" width="25" alt="Switch"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['PLAN_REVIEWER']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PLAN_REVIEWER']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="action.planReviewedBy"
                (closed)="planReviewerSearchText=''" (click)="focusSearch('focus-plan-reviewer')"
                (keydown.enter)="focusSearch('focus-plan-reviewer')" [disabled]="true">
                <input type="search" id="focus-plan-reviewer" class="dropdownsearchstyle"
                  [(ngModel)]="planReviewerSearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of reviewerDropdown | assessmentSearch :planReviewerSearchText"
                  [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3" *ngIf="action.planApprovedBy">
              <div>
                <label id="plan-approver" for="email">
                  {{dynamicLabel['PLAN_APPROVER']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <label for="email" *ngIf="message.showSwitchUser  && !action.planApprovalCompletedOn"
                  (click)="openSwitchUser('Plan Approver')" (keydown.enter)="openSwitchUser('Plan Approver')">
                  <a>
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" width="25" alt="Switch"
                      height="25">
                  </a>
                </label>

                <span style="float:right" *ngIf="dynamicLabel['PLAN_APPROVER']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PLAN_APPROVER']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="action.planApprovedBy"
                (closed)="planApproverSearchText = ''" (click)="focusSearch('focus-plan-approver')"
                (keydown.enter)="focusSearch('focus-plan-approver')" [disabled]="true">
                <input type="search" id="focus-plan-approver" class="dropdownsearchstyle"
                  [(ngModel)]="planApproverSearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of approverDropdown | assessmentSearch :planApproverSearchText"
                  [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['PLAN_REVIEW_REQUESTED_ON']?.isRemovable != 'Y' && action.planReviewRequestedOn">
              <div>
                <label for="email">
                  {{dynamicLabel['PLAN_REVIEW_REQUESTED_ON']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['PLAN_REVIEW_REQUESTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PLAN_REVIEW_REQUESTED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.planReviewRequestedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['PLAN_REVIEW_COMPLETED_ON']?.isRemovable != 'Y' && action.planReviewCompletedOn">
              <div>
                <label for="email">
                  {{dynamicLabel['PLAN_REVIEW_COMPLETED_ON']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['PLAN_REVIEW_COMPLETED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PLAN_REVIEW_COMPLETED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.planReviewCompletedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['PLAN_REVIEW_REJECTED_ON']?.isRemovable != 'Y' && action.planReviewRejectedOn">
              <div>
                <label for="email">{{dynamicLabel['PLAN_REVIEW_REJECTED_ON']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['PLAN_REVIEW_REJECTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PLAN_REVIEW_REJECTED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.planReviewRejectedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-6"
              *ngIf="dynamicLabel['PLAN_REVIEW_COMMENTS']?.isRemovable != 'Y' && action.planReviewComments">
              <div>
                <label for="email">
                  {{dynamicLabel['PLAN_REVIEW_COMMENTS']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['PLAN_REVIEW_COMMENTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PLAN_REVIEW_COMMENTS']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50"
                [(ngModel)]="action.planReviewComments" [disabled]="true"></textarea>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['PLAN_APPROVAL_REQUESTED_ON']?.isRemovable != 'Y' && action.planApprovalRequestedOn">
              <div>
                <label for="email">{{dynamicLabel['PLAN_APPROVAL_REQUESTED_ON']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['PLAN_APPROVAL_REQUESTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PLAN_APPROVAL_REQUESTED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.planApprovalRequestedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['PLAN_APPROVAL_COMPLETED_ON']?.isRemovable != 'Y' && action.planApprovalCompletedOn">
              <div>
                <label for="email">{{dynamicLabel['PLAN_APPROVAL_COMPLETED_ON']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['PLAN_APPROVAL_COMPLETED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PLAN_APPROVAL_COMPLETED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.planApprovalCompletedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['PLAN_APPROVAL_REJECTED_ON']?.isRemovable != 'Y' && action.planApprovalRejectedOn">
              <div>
                <label for="email">{{dynamicLabel['PLAN_APPROVAL_REJECTED_ON']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['PLAN_APPROVAL_REJECTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PLAN_APPROVAL_REJECTED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.planApprovalRejectedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-6"
              *ngIf="dynamicLabel['PLAN_APPROVAL_COMMENTS']?.isRemovable != 'Y' && action.planApprovalComments">
              <div>
                <label for="email">
                  {{dynamicLabel['PLAN_APPROVAL_COMMENTS']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['PLAN_APPROVAL_COMMENTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PLAN_APPROVAL_COMMENTS']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50"
                [(ngModel)]="action.planApprovalComments" [disabled]="true"></textarea>
            </div>
          </div>
        </fieldset>

        <!-- Defer Details  -->
        <fieldset class="border p-2 field-set" *ngIf="action.deferReviewedByUser || action.deferApprovedByUser">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Defer Details</span>
          </legend>

          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-3" *ngIf="action.deferReviewedByUser">
              <div>
                <label id="defer-reviewer" for="email">
                  {{dynamicLabel['DEFER_REVIEWER']?.fieldName}}
                </label>
                <label for="email" *ngIf="message.showSwitchUser" (click)="openSwitchUser('Defer Reviewer')"
                  (keydown.enter)="openSwitchUser('Defer Reviewer')">
                  <a>
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" width="25" alt="switch"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['DEFER_REVIEWER']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DEFER_REVIEWER']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select [ngClass]="{'odd-item-mat-select': oddDeferReviewer == action.deferReviewedByUser}" matInput
                placeholder="Select" [(ngModel)]="action.deferReviewedByUser" (closed)="deferReviewerSearchText=''"
                (click)="focusSearch('deferReviewer')" (keydown.enter)="focusSearch('deferReviewer')" [disabled]="true">
                <input type="search" id="deferReviewer" class="dropdownsearchstyle"
                  [(ngModel)]="deferReviewerSearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onDeferReviewerSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of deferReviewerDropdown| assessmentSearch :deferReviewerSearchText"
                  (onSelectionChange)="onDeferReviewerSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3" *ngIf="action.deferApprovedByUser">
              <div>
                <label id="defer-approver" for="email">
                  {{dynamicLabel['DEFER_APPROVER']?.fieldName}}
                </label>
                <label for="email" *ngIf="message.showSwitchUser" (click)="openSwitchUser('Defer Approver')"
                  (keydown.enter)="openSwitchUser('Defer Approver')">
                  <a>
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="switch" width="25"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['DEFER_APPROVER']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DEFER_APPROVER']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select [ngClass]="{'odd-item-mat-select': oddDeferApprover == action.deferApprovedByUser}" matInput
                placeholder="Select" [(ngModel)]="action.deferApprovedByUser" (closed)="deferApproverSearchText=''"
                (click)="focusSearch('focus-d2-approver')" (keydown.enter)="focusSearch('focus-d2-approver')"
                [disabled]="true">
                <input type="search" id="focus-d2-approver" class="dropdownsearchstyle"
                  [(ngModel)]="deferApproverSearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onDeferApproverSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of deferApproverDropdown| assessmentSearch :deferApproverSearchText"
                  (onSelectionChange)="onDeferApproverSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-6" *ngIf="dynamicLabel['DEFER_REASON']?.isRemovable != 'Y' && action.deferReason">
              <div>
                <label for="email">{{dynamicLabel['DEFER_REASON']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['DEFER_REASON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DEFER_REASON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50" [(ngModel)]="action.deferReason"
                [disabled]="true"></textarea>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['DEFER_REVIEW_REQUESTED_ON']?.isRemovable != 'Y' && action.deferReviewRequestedOn">
              <div>
                <label for="email">
                  {{dynamicLabel['DEFER_REVIEW_REQUESTED_ON']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['DEFER_REVIEW_REQUESTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DEFER_REVIEW_REQUESTED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.deferReviewRequestedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['DEFER_REVIEW_COMPLETED_ON']?.isRemovable != 'Y' && action.deferReviewCompletedOn">
              <div>
                <label for="email">
                  {{dynamicLabel['DEFER_REVIEW_COMPLETED_ON']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['DEFER_REVIEW_COMPLETED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DEFER_REVIEW_COMPLETED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.deferReviewCompletedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['DEFER_REVIEW_REJECTED_ON']?.isRemovable != 'Y' && action.deferReviewRejectedOn">
              <div>
                <label for="email">
                  {{dynamicLabel['DEFER_REVIEW_REJECTED_ON']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['DEFER_REVIEW_REJECTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DEFER_REVIEW_REJECTED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.deferReviewRejectedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-6"
              *ngIf="dynamicLabel['DEFER_REVIEW_COMMENTS']?.isRemovable != 'Y' && action.deferReviewComments">
              <div>
                <label for="email">
                  {{dynamicLabel['DEFER_REVIEW_COMMENTS']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['DEFER_REVIEW_COMMENTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DEFER_REVIEW_COMMENTS']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50"
                [(ngModel)]="action.deferReviewComments" [disabled]="true"></textarea>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['DEFER_APPROVAL_REQUESTED_ON']?.isRemovable != 'Y' && action.deferApprovalRequestedOn">
              <div>
                <label for="email">{{dynamicLabel['DEFER_APPROVAL_REQUESTED_ON']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['DEFER_APPROVAL_REQUESTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DEFER_APPROVAL_REQUESTED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.deferApprovalRequestedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['DEFER_APPROVAL_COMPLETED_ON']?.isRemovable != 'Y' && action.deferApprovalCompletedOn">
              <div>
                <label for="email">{{dynamicLabel['DEFER_APPROVAL_COMPLETED_ON']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['DEFER_APPROVAL_COMPLETED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DEFER_APPROVAL_COMPLETED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.deferApprovalCompletedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['DEFER_APPROVAL_REJECTED_ON']?.isRemovable != 'Y' && action.deferApprovalRejectedOn">
              <div>
                <label for="email">
                  {{dynamicLabel['DEFER_APPROVAL_REJECTED_ON']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['DEFER_APPROVAL_REJECTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DEFER_APPROVAL_REJECTED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.deferApprovalRejectedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-6"
              *ngIf="dynamicLabel['DEFER_APPROVAL_COMMENTS']?.isRemovable != 'Y' && action.deferApprovalComments">
              <div>
                <label for="email">
                  {{dynamicLabel['DEFER_APPROVAL_COMMENTS']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['DEFER_APPROVAL_COMMENTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DEFER_APPROVAL_COMMENTS']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50"
                [(ngModel)]="action.deferApprovalComments" [disabled]="true"></textarea>
            </div>
          </div>
        </fieldset>

        <!-- Implementation Details  -->
        <fieldset class="border p-2 field-set"
          *ngIf="(action.status == 'In Progress' || action.status == 'Deferred(Review Rejected)' || action.status == 'Deferred(Approval Rejected)' || action.status == 'Implementation Review Rejected' || action.status == 'Implementation Approval Rejected' || action.status == 'Pending Implementation Review' || action.status == 'Pending Implementation Approval' || action.status == 'Completed')">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Implementation Details</span>
          </legend>

          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-2">
              <div>
                <label id='action-performed' for="email">
                  {{dynamicLabel['ACTION_PERFORMED']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['ACTION_PERFORMED']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ACTION_PERFORMED']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-slide-toggle color="primary" [(ngModel)]="action.actionPerformed" [disabled]="isExecutionFrozen"
                (change)="onActionPerformedChange()">
                <span class="active-inActive-container" [ngStyle]="{ color: action.actionPerformed ? 'green' : 'red' }">
                  {{ action.actionPerformed ? 'Yes' : 'No' }}
                </span>
              </mat-slide-toggle>
            </div>

            <div class="col-md-5" *ngIf="action.actionPerformed">
              <div>
                <label id="performed-action-details" for="email">
                  {{dynamicLabel['PERFORMED_ACTION_DETAILS']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['PERFORMED_ACTION_DETAILS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PERFORMED_ACTION_DETAILS']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="row d-flex align-items-center">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="action.performedActionDetails" [config]="excludeButtons"
                    style="min-height: 100px !important;" [spellcheck]="true" (paste)="onPaste($event)">
                  </st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (click)="isExecutionFrozen ? openEditor('Performed Action Details', 'eye') : openEditor('Performed Action Details', 'edit')"
                  (keydown.enter)="isExecutionFrozen ? openEditor('Performed Action Details', 'eye') : openEditor('Performed Action Details', 'edit')">
                  <i *ngIf="!isExecutionFrozen" class="far fa-edit"></i>
                  <i *ngIf="isExecutionFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>

            <div class="col-md-5" *ngIf="action.actionPerformed && dynamicLabel['JUSTIFICATION'].isRemovable != 'Y'">
              <!-- Additional Remark -->
              <div>
                <label id="justification" for="email">
                  {{dynamicLabel['JUSTIFICATION'].fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['JUSTIFICATION'].fieldNotes"
                  [matTooltip]="dynamicLabel['JUSTIFICATION'].fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50" [(ngModel)]="action.justification"
                [disabled]="isExecutionFrozen"></textarea>
            </div>

            <div class="col-md-2" *ngIf="action.actionPerformed">
              <label id="actual-action-completed-on" for="email">
                {{dynamicLabel['ACTUAL_ACTION_COMPLETED_ON'].fieldName}}
              </label>
              <span style="float:right" *ngIf="dynamicLabel['ACTUAL_ACTION_COMPLETED_ON'].fieldNotes"
                [matTooltip]="dynamicLabel['ACTUAL_ACTION_COMPLETED_ON'].fieldNotes">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
              </span>
              <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="$getDynamicConfig()"
                [dateCustomClasses]="dateCustomClasses" [(ngModel)]="action.actualActionCompletedOn"
                [disabled]="isExecutionFrozen">
            </div>

            <div class="col-md-3" *ngIf="action.reviewedByUser">
              <div>
                <label id="reviewer" for="email">
                  {{dynamicLabel['REVIEWER']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <label for="email" *ngIf="message.showSwitchUser" (click)="openSwitchUser('Reviewer')"
                  (keydown.enter)="openSwitchUser('Reviewer')">
                  <a>
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" width="25" alt="Switch"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['REVIEWER']?.fieldNotes"
                  [matTooltip]="dynamicLabel['REVIEWER']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="action.reviewedByUser"
                (closed)="reviewerSearchText=''" (click)="focusSearch('reviewer')"
                (keydown.enter)="focusSearch('reviewer')" [disabled]="true"
                [ngClass]="{'odd-item-mat-select':oddReviewer == action.reviewedByUser}">
                <input type="search" class="dropdownsearchstyle" [(ngModel)]="reviewerSearchText" matInput
                  placeholder="search">
                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of reviewerDropdown| assessmentSearch :reviewerSearchText"
                  [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3" [hidden]="!this.action.approvedByUser">
              <div>
                <label id="approver" for="email">
                  {{dynamicLabel['APPROVER']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <label for="email" *ngIf="message.showSwitchUser" (click)="openSwitchUser('Approver')"
                  (keydown.enter)="openSwitchUser('Approver')">
                  <a>
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="email" width="25"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['APPROVER']?.fieldNotes"
                  [matTooltip]="dynamicLabel['APPROVER']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="action.approvedByUser"
                (closed)="approverSearchText=''" (click)="focusSearch('approver')"
                (keydown.enter)="focusSearch('deferApprover')" [disabled]="true"
                [ngClass]="{'odd-item-mat-select': oddApprover == action.approvedByUser}">
                <input type="search" class="dropdownsearchstyle" [(ngModel)]="approverSearchText" matInput
                  placeholder="search">
                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of approverDropdown| assessmentSearch :approverSearchText"
                  [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['REVIEW_REQUESTED_ON']?.isRemovable != 'Y' && action.reviewRequestedOn">
              <div>
                <label for="email">
                  {{dynamicLabel['REVIEW_REQUESTED_ON']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['REVIEW_REQUESTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['REVIEW_REQUESTED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.reviewRequestedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['REVIEW_COMPLETED_ON']?.isRemovable != 'Y' && action.reviewCompletedOn">
              <div>
                <label for="email">
                  {{dynamicLabel['REVIEW_COMPLETED_ON']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['REVIEW_COMPLETED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['REVIEW_COMPLETED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.reviewCompletedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['REVIEW_REJECTED_ON']?.isRemovable != 'Y' && action.reviewRejectedOn">
              <div>
                <label for="email">
                  {{dynamicLabel['REVIEW_REJECTED_ON']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['REVIEW_REJECTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['REVIEW_REJECTED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.reviewRejectedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-6" *ngIf="dynamicLabel['REVIEW_COMMENTS']?.isRemovable != 'Y' && action.reviewComments">
              <div>
                <label id="justification-validation" for="email">{{dynamicLabel['REVIEW_COMMENTS']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['REVIEW_COMMENTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['REVIEW_COMMENTS']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50" [(ngModel)]="action.reviewComments"
                [disabled]="true"></textarea>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['APPROVAL_REQUESTED_ON']?.isRemovable != 'Y' && action.approvalRequestedOn">
              <div>
                <label for="email">{{dynamicLabel['APPROVAL_REQUESTED_ON']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['APPROVAL_REQUESTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['APPROVAL_REQUESTED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.approvalRequestedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['APPROVAL_COMPLETED_ON']?.isRemovable != 'Y' && action.approvalCompletedOn">
              <div>
                <label for="email">{{dynamicLabel['APPROVAL_COMPLETED_ON']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['APPROVAL_COMPLETED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['APPROVAL_COMPLETED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.approvalCompletedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-3"
              *ngIf="dynamicLabel['APPROVAL_REJECTED_ON']?.isRemovable != 'Y' && action.approvalRejectedOn">
              <div>
                <label for="email">
                  {{dynamicLabel['APPROVAL_REJECTED_ON']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['APPROVAL_REJECTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['APPROVAL_REJECTED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">
                {{action.approvalRejectedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
              </div>
            </div>

            <div class="col-md-6"
              *ngIf="dynamicLabel['APPROVAL_COMMENTS']?.isRemovable != 'Y' && action.approvalComments">
              <div>
                <label for="email">{{dynamicLabel['APPROVAL_COMMENTS']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['APPROVAL_COMMENTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['APPROVAL_COMMENTS']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50"
                [(ngModel)]="action.approvalComments" [disabled]="true"></textarea>
            </div>

            <div class="col-md-3" *ngIf="action.actionCompletedOn">
              <label id="actionCompletedOn-validation" for="email">
                {{dynamicLabel['ACTION_COMPLETED_ON']?.fieldName}}
              </label>
              <span style="float:right" *ngIf="dynamicLabel['ACTION_COMPLETED_ON']?.fieldNotes"
                [matTooltip]="dynamicLabel['ACTION_COMPLETED_ON']?.fieldNotes">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
              </span>
              <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="$dateTimeConfig"
                [dateCustomClasses]="dateCustomClasses" [(ngModel)]="action.actionCompletedOn"
                [disabled]="isPlanFrozen">
            </div>

          </div>
        </fieldset>
      </div>

      <div mat-dialog-actions class="btn-align">
        <div class="button-continer" *ngFor="let button of buttonList" style="margin-left: 10px;">
          <button *ngIf="button == 'Cancel' && button != '' " mat-stroked-button class="cancelButton"
            (click)="cancelAddOrEditPopup()">
            {{button}}</button>
          <button *ngIf="button == 'Save' && button != ''" mat-stroked-button class="addButton"
            (click)="addOrEdit(action)">
            {{button}}</button>
          <button *ngIf="button != 'Cancel' && button != '' && button != 'Save'" mat-stroked-button class="addButton"
            (click)="dynamicButtonClick(button)"> {{button}}</button>
        </div>
      </div>

      <div class="form-template ActivityPage" *ngIf="this.visibleEditButton" id="Documents" style="margin-top:1%;">
        <div class="menu-container">
          <div class="row menu-row-container">
            <div class="col-sm-6 gridName-container">
              <span class="gridName">Documents</span>
            </div>
          </div>
        </div>
        <app-task-documents [activity]="this.objForDocuments"></app-task-documents>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeletePopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Delete Preliminary Action </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div>
            <label id="delete-reason" for="email">Reason for Delete</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <textarea id="deleteTextarea" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="action.deleteReason" (ngModelChange)="onNgModelChange($event,'delete-reason')"></textarea>
        </div>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction(action)">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeletePopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #performOperationPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReasonPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ buttonLabel }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span></label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="">
      <div class="col-sm-12"
        *ngIf="buttonLabel =='Review'|| buttonLabel ==='Approve' || buttonLabel ==='Plan Review' || buttonLabel ==='Plan Approve'">
        <div>
          <label id="radio-status" for="email">{{buttonLabel}}</label>
          <span class="mandatory-symbol">*</span>
        </div>
        <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedStatus"
          (ngModelChange)="onNgModelChange($event,'radio-status')">
          <mat-radio-button class="tp-radio-button" *ngFor="let status of reviewStatus" [value]="status">
            {{status}}
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="col-md-12 fieldStyle3" *ngIf="isESignRequired">
        <div class=""><label for="username ">User Name</label><span class="mandatory-symbol">*</span>
        </div>
        <div class=""> <input id="username" style="height: 80% !important;" class="input-filed-continers" type="text"
            [(ngModel)]="userName" disabled></div>
      </div>

      <div class="col-md-12" *ngIf="(isESignRequired && !isAdEnabled)">
        <div class="">
          <label id="password" for="password">
            Password
          </label>
          <span class="mandatory-symbol">*</span>
        </div>
        <div class=""> <input id="EsignRequiredPassword" autocomplete="off" onpaste="return false;"
            ondrop="return false;" style="height: 80% !important;" class="input-filed-continers"
            [type]="hidePassword ? 'password' : 'text'" [(ngModel)]="password" noCopyPaste
            (ngModelChange)="onNgModelChange($event,'password')">
          <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
            <i [class]="hidePassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
          </span>
        </div>
      </div>

      <div class="col-md-12"
        *ngIf="(buttonLabel == 'Submit for Plan Review' || buttonLabel == 'Re-Submit for Plan Review') && action.planReviewedBy != 0">
        <div>
          <label id="p-plan-reviewer" for="email">
            {{dynamicLabel['PLAN_REVIEWER']?.fieldName}}
          </label> <span class="mandatory-symbol">*</span>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="action.planReviewedBy"
          (closed)="planReviewerSearchText=''" (click)="focusSearch('focus-plan-p-reviewer')"
          (keydown.enter)="focusSearch('focus-plan-p-reviewer')">
          <input type="search" id="focus-plan-p-reviewer" class="dropdownsearchstyle"
            [(ngModel)]="planReviewerSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onPlanReviewerSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of reviewerDropdown | assessmentSearch :planReviewerSearchText"
            [value]="item.valueExp" (onSelectionChange)="onPlanReviewerSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

      <div class="col-md-12"
        *ngIf="(buttonLabel == 'Submit for Plan Approval' || buttonLabel == 'Re-Submit for Plan Approval' || buttonLabel == 'Submit for Plan Review' || buttonLabel == 'Re-Submit for Plan Review') && action.planApprovedBy != 0">
        <div>
          <label id="p-plan-approver" for="email">
            {{dynamicLabel['PLAN_APPROVER']?.fieldName}}
          </label> <span class="mandatory-symbol">*</span>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="action.planApprovedBy"
          (closed)="planApproverSearchText = ''" (click)="focusSearch('focus-plan-p-approver')"
          (keydown.enter)="focusSearch('focus-plan-p-approver')">
          <input type="search" id="focus-plan-p-approverr" class="dropdownsearchstyle"
            [(ngModel)]="planApproverSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onPlanApproverSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of approverDropdown | assessmentSearch :planApproverSearchText"
            [value]="item.valueExp" (onSelectionChange)="onPlanApproverSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

      <div class="col-md-12"
        *ngIf="(buttonLabel == 'Submit for Implementation Review' || buttonLabel == 'Re-Submit for Implementation Review') && action.reviewedByUser != 0">
        <div>
          <label id="p-reviewer" for="email">
            {{dynamicLabel['REVIEWER']?.fieldName}}
          </label> <span class="mandatory-symbol">*</span>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="action.reviewedByUser" (closed)="reviewerSearchText=''"
          (click)="focusSearch('focus-reviewer')" (keydown.enter)="focusSearch('focus-reviewer')">
          <input type="search" id="focus-reviewer" class="dropdownsearchstyle" [(ngModel)]="reviewerSearchText" matInput
            placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onReviewerSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of reviewerDropdown| assessmentSearch :reviewerSearchText"
            [value]="item.valueExp" (onSelectionChange)="onReviewerSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

      <div class="col-md-12"
        *ngIf="(buttonLabel == 'Submit for Implementation Approval' || buttonLabel == 'Re-Submit for Implementation Approval' || buttonLabel == 'Submit for Implementation Review' || buttonLabel == 'Re-Submit for Implementation Review') && action.approvedByUser != 0">
        <div>
          <label id="p-approver" for="email">
            {{dynamicLabel['APPROVER']?.fieldName}}
          </label> <span class="mandatory-symbol">*</span>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="action.approvedByUser" (closed)="approverSearchText=''"
          (click)="focusSearch('focus-approver')" (keydown.enter)="focusSearch('focus-approver')">
          <input type="search" id="focus-approver" class="dropdownsearchstyle" [(ngModel)]="approverSearchText" matInput
            placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onApproverSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of approverDropdown| assessmentSearch :approverSearchText"
            [value]="item.valueExp" (onSelectionChange)="onApproverSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

      <div class="mt-2" [ngStyle]="{'border': buttonLabel=='Defer Action' ? '1px solid #cfcfcf' : '' }"
        *ngIf="buttonLabel == 'Defer Action' || buttonLabel == 'Re-Submit for Defer Action'">
        <div class="col-md-12">
          <div>
            <label id="p-defer-reviewer" for="email">
              {{dynamicLabel['DEFER_REVIEWER']?.fieldName}}
            </label> <span class="mandatory-symbol">*</span>
          </div>
          <mat-select matInput placeholder="Select"
            [ngClass]="{'odd-item-mat-select': oddDeferReviewer == action.deferReviewedByUser}"
            [(ngModel)]="action.deferReviewedByUser" (closed)="deferReviewerSearchText=''"
            (click)="focusSearch('focus-d-reviewer')" (keydown.enter)="focusSearch('focus-d-reviewer')">
            <input type="search" id="focus-d-reviewer" class="dropdownsearchstyle" [(ngModel)]="deferReviewerSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onDeferReviewerSelect($event,null)">Un-select</mat-option>
            <mat-option *ngFor="let item of deferReviewerDropdown| assessmentSearch :deferReviewerSearchText"
              (onSelectionChange)="onDeferReviewerSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-12">
          <div>
            <label id="p-defer-approver" for="email">
              {{dynamicLabel['DEFER_APPROVER']?.fieldName}}
            </label> <span class="mandatory-symbol">*</span>
          </div>
          <mat-select matInput placeholder="Select"
            [ngClass]="{'odd-item-mat-select': oddDeferApprover == action.deferApprovedByUser}"
            [(ngModel)]="action.deferApprovedByUser" (closed)="deferApproverSearchText=''"
            (click)="focusSearch('focus-d-approver')" (keydown.enter)="focusSearch('focus-d-approver')">
            <input type="search" id="focus-d-approver" class="dropdownsearchstyle" [(ngModel)]="deferApproverSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onDeferApproverSelect($event,null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of deferApproverDropdown| assessmentSearch :deferApproverSearchText"
              (onSelectionChange)="onDeferApproverSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <div class="col-md-12"
        *ngIf="buttonLabel == 'Review' || buttonLabel == 'Approve' || buttonLabel == 'Plan Review' || buttonLabel == 'Plan Approve' || buttonLabel == 'Defer Action' || buttonLabel == 'Re-Submit for Defer Action'">
        <div>
          <label id="reason" for="reason">
            {{(buttonLabel == 'Defer Action' || buttonLabel == 'Re-Submit for Defer Action') ?
            'Defer Reason' : 'Comments'}}
          </label> <span class="mandatory-symbol"
            *ngIf="selectedStatus.includes('Rejected') || (buttonLabel == 'Defer Action' || buttonLabel == 'Re-Submit for Defer Action')">*</span>
        </div>
        <textarea rows="4" class="input-filed-textarea" type="text" [(ngModel)]="reason"
          (ngModelChange)="onNgModelChange($event,'reason')"></textarea>
      </div>

    </div> <br>

    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="performOperation()">
        {{(buttonLabel == 'Defer Action' || buttonLabel == 'Re-Submit for Defer Action')
        ? 'Submit' : buttonLabel}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelReasonPopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #editor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelEditor()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ editorTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div><br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]=" allowEditing ? includeButtons : excludeButtons"
        [spellcheck]="true" (paste)="onPaste($event)"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" *ngIf="allowEditing" (click)="saveEditor(editorValue)">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #reorderPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReorder()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Preliminary Actions Reorder </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <b class="align-center">
      Drag and drop to reorder the Preliminary Actions
    </b>
    <div class="table-container">
      <table style="max-height: 65vh;">
        <thead>
          <th class="control-text" style="width: 240px; text-align: center;">
            <span> Action Seq. </span>
            <span class="grid-header-container"> </span>
          </th>
          <th class="control-text" style="width: 240px; text-align: left;">
            <span> Action Name </span>
            <span class="grid-header-container"> </span>
          </th>
          <th class="control-text" style="width: 150px; text-align: center;">
            <span> New Seq. </span>
            <span class="grid-header-container"></span>
          </th>
        </thead>
        <tbody cdkDropList (cdkDropListDropped)="dragAndDrop($event)">
          <tr cdkDrag cdkDragLockAxis="y" cdkDragHandle *ngFor="let i of grid; let idx = index;">
            <td class="control-text" style="width: 240px; text-align: center;">
              <span> {{ i.SL_NO }} </span>
            </td>
            <td class="control-text" style="width: 240px; text-align: left;">
              <span> {{ i.ACTION_NAME }} </span>
            </td>
            <td class="control-text" style="width: 240px; text-align: center;">
              <span> {{ i.NEW_ORDER }} </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="reorderPreActions()" [disabled]="!isReordered">
        <i class="fa fa-redorder"></i> Reorder
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelReorder()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<app-switchuser #switchUserPopup1 (valueEmitter)="onChildValueEmitted()" [user]="userId"></app-switchuser>
<app-editor #clobViewPopup></app-editor>
<app-search-users (valueEmitter)="onSearchUserEmitted()"></app-search-users>
